import * as React from 'react';
import offerOne from './assets/offer-one.svg';
import offerTwo from './assets/offer-two.svg';
import offerThree from './assets/offer-three.svg';

import { ElementInViewport } from '../../../../packages/ElementInViewport';
import { LandingBlock } from '../LandingBlock';
import { ContentWrapper } from '../ContentWrapper';
import { BlockHeader } from '../BlockHeader';

import { trackShowTenMinutesBlock } from './tracking';

import * as styles from './styles.css';

export const OffersTenMinutes = () => {
  const onElementInViewPort = React.useCallback(() => {
    trackShowTenMinutesBlock();
  }, [trackShowTenMinutesBlock]);

  return (
    <ElementInViewport onVisibleFirst={onElementInViewPort}>
      <LandingBlock>
        <ContentWrapper>
          <BlockHeader>Получите предложения по&nbsp;ипотеке&nbsp;бесплатно за&nbsp;10&nbsp;минут</BlockHeader>
          <div className={styles['offers-container']}>
            <div className={styles['main-container']}>
              <img className={styles['image']} src={offerThree} />
              <div className={styles['text-container']}>
                Вы получите реальные процентные ставки, как если бы обратились в банк напрямую, никаких скрытых комиссий
              </div>
            </div>
            <div className={styles['main-container']}>
              <img className={styles['image']} src={offerTwo} />
              <div className={styles['text-container']}>
                Сервис бесплатный благодаря договорённостям, которые мы заключили с банками
              </div>
            </div>
            <div className={styles['main-container']}>
              <img className={styles['image']} src={offerOne} />
              <div className={styles['text-container']}>
                Для получения предложений от банков нужны только паспорт и название работодателя
              </div>
            </div>
          </div>
        </ContentWrapper>
      </LandingBlock>
    </ElementInViewport>
  );
};
